import { ref } from "vue";
import axios from "axios";
import authHeader from "@/Api/AuthHeader";
const URL_API = process.env.VUE_APP_URL_API;

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async addGroup(data) {
      try {
        let data1 = new FormData();

        data1.append("title", data.title);
        data1.append("description", data.description);

        const resp = await axios.post(URL_API + "group", data1, {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },

    async provinces() {
      try {
        const resp = await axios.get(URL_API + "provinces", {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },

    async districtsByProvinceId(id) {
      try {
        const resp = await axios.get(URL_API + `district/${id}`, {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },

    async getGroups() {
      try {
        const resp = await axios.get(URL_API + `group`, {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },

    async getAllGroups() {
      try {
        const resp = await axios.get(URL_API + `getAllGroups`, {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },

    async getGroupById(id) {
      try {
        const resp = await axios.get(URL_API + `group/${id}`, {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },

    async updateGroup(data, id) {
      try {
        let dat = new FormData();

        dat.append("title", data.title);
        dat.append("description", data.description);
        dat.append("id", id);

        const resp = await axios.post(URL_API + `updateGroup`, dat, {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getMyProduct(user_id) {
      try {
        const resp = await axios.get(URL_API + `getMyProduct/${user_id}`, {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },

    async markProductUnvailable(id) {
      try {
        const resp = await axios.get(
          `/Api/api/markProductUnvailable?product_id=${id}`,
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },

    async markProductAvailable(id) {
      try {
        const resp = await axios.get(
          `/Api/api/markProductAvailable?product_id=${id}`,
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },

    async removeProduct(id) {
      try {
        const resp = await axios.get(
          `/Api/api/removeProduct?product_id=${id}`,
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getMyTotalProduct(id) {
      try {
        const resp = await axios.get(
          `/Api/api/getMyTotalProduct?person_id=${id}`,
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getTotalProductAvailable(id) {
      try {
        const resp = await axios.get(
          `/Api/api/getTotalProductAvailable?person_id=${id}`,
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getTotalProductUnvailable(id) {
      try {
        const resp = await axios.get(
          `/Api/api/getTotalProductUnvailable?person_id=${id}`,
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getTotalProductUnvailableRent(id) {
      try {
        const resp = await axios.get(
          `/Api/api/getTotalProductUnvailableRent?person_id=${id}`,
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },
  },
};
